import { ViewModeSelector } from "./ViewModeSelector";

export default ViewModeSelector;
